export const BASE_URL = "https://cineverse-jg3j.onrender.com";
